import * as React from 'react';
import cx from 'classnames';
import { Checkbox } from '../../../../checkbox';
import * as styles from './styles.css';
export var MultiSelectDesktopDropdownItem = /*#__PURE__*/React.forwardRef(function MultiSelectDesktopDropdownItem(_ref, forwardedRef) {
  var value = _ref.value,
    label = _ref.label,
    name = _ref.name,
    focused = _ref.focused,
    selected = _ref.selected,
    onClick = _ref.onClick,
    onMouseMove = _ref.onMouseMove;
  return /*#__PURE__*/React.createElement("div", {
    ref: focused ? forwardedRef : undefined,
    className: cx(styles['checkbox-wrapper'], focused && styles['focused']),
    onClick: onClick,
    onMouseMove: onMouseMove,
    role: "option",
    "aria-selected": selected ? 'true' : undefined,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: name,
    value: value,
    checked: selected,
    label: label,
    tabIndex: -1,
    onClick: preventDefault
  }));
});
function preventDefault(event) {
  event.preventDefault();
}